<template>
	<svg
		width="17"
		height="16"
		viewBox="0 0 17 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.04545 3L13.5 3M13.5 3L13.5 9.45455M13.5 3L3.5 13"
			stroke="#211752"
			stroke-width="2"
			stroke-linecap="square"
		/>
	</svg>

</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>




// WEBPACK FOOTER //
// resources/assets/scripts/vue/ExternalLink.vue